import React, {useMemo, useState}from 'react'
// import { useParams } from 'react-router-dom'
// import Loader from '../Components/Loader'
import { useAxiosGet } from '../Hooks/HttpRequests'
import Table from '../Components/Table'
import TradeTable from '../Components/TradeTable'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Divider from '@mui/material/Divider';
import MuiTable from '../Components/MuiTable'
import OutlinedCard from '../Components/OutlinedCard';
import { TableTooltip, BasicTooltip, Chip } from '@nivo/tooltip'
import { ResponsiveChord, Chord, ArcDatum, ArcTooltipComponentProps, RibbonTooltipComponentProps } from '@nivo/chord'
import { smdTeams } from '../data/teamMap'


function ChordTest({ url }){


  const ArcTooltip = ({ arc }: ArcTooltipComponentProps) => (
    <BasicTooltip
        id={`Custom arc tooltip, ${arc.label}`}
        value={arc.formattedValue}
        color={arc.color}
        enableChip={true}
        textcolor={arc.color}
    />
  )

  const RibbonTooltip = ({ ribbon }: RibbonTooltipComponentProps) => (
      <TableTooltip
          rows={[
              [
                  <Chip key="chip" color={ribbon.source.color} />,
                  'Source (custom)',
                  <strong key="id">{ribbon.source.id}</strong>,
                  ribbon.source.value,
              ],
              [
                  <Chip key="chip" color={ribbon.target.color} />,
                  'Target (custom)',
                  <strong key="id">{ribbon.target.id}</strong>,
                  ribbon.target.value,
              ],
          ]}
      />
  )

  const MyChord = ({ matrix, keys }) => (
    <Chord
      data={matrix}
      height={750}
      width={750}
      keys={keys}
        margin={{ top: 60, right: 60, bottom: 90, left: 60 }}
        valueFormat=".2f"
        padAngle={0.02}
        innerRadiusRatio={0.96}
        innerRadiusOffset={0.02}
        inactiveArcOpacity={0.25}
        // arcTooltip={ArcTooltip}
        // ribbonTooltip={RibbonTooltip}
        arcBorderColor={{
            from: 'color',
            modifiers: [
                [
                    'darker',
                    0.6
                ]
            ]
        }}
        activeRibbonOpacity={1}
        inactiveRibbonOpacity={0.25}
        ribbonBorderColor={{
            from: 'color',
            modifiers: [
                [
                    'darker',
                    0.6
                ]
            ]
        }}
        labelRotation={-90}
        labelTextColor={{
          from: 'color',
          modifiers: [
              [
                  'darker',
                  1
              ]
          ]
      }}
        colors={{ scheme: 'category10' }}
        motionConfig="stiff"
        // legends={[
        //     {
        //         anchor: 'bottom',
        //         direction: 'row',
        //         justify: false,
        //         translateX: 0,
        //         translateY: 70,
        //         itemWidth: 80,
        //         itemHeight: 14,
        //         itemsSpacing: 0,
        //         itemTextColor: '#999',
        //         itemDirection: 'left-to-right',
        //         symbolSize: 12,
        //         symbolShape: 'circle',
        //         effects: [
        //             {
        //                 on: 'hover',
        //                 style: {
        //                     itemTextColor: '#000'
        //                 }
        //             }
        //         ]
        //     }
        // ]}
    />
)

  // Build matrix from ByPartner JSON
  const partnersUrl = url || 'https://supermegadynasty.com/smd_trades_by_partner.json'
  const { data } = useAxiosGet(partnersUrl)

  // Order keys by league team map for consistency
  const keys = useMemo(() => smdTeams.map(t => t.username), [])

  const matrix = useMemo(() => {
    const size = keys.length
    const m = Array.from({ length: size }, () => Array(size).fill(0))
    if (!data) return m

    const rows = Array.isArray(data) ? data : (typeof data === 'object' ? Object.values(data) : [])
    const indexOf = (name) => keys.indexOf(String(name))

    rows.forEach(row => {
      const i = indexOf(row.username)
      if (i === -1) return
      keys.forEach((partner, j) => {
        if (i === j) { m[i][j] = 0; return }
        const v = Number(row[partner])
        m[i][j] = isNaN(v) ? 0 : v
      })
    })
    return m
  }, [data, keys])

  const ready = useMemo(() => (
    Array.isArray(matrix) && matrix.length === keys.length && matrix.length > 0 &&
    matrix.every(row => Array.isArray(row) && row.length === keys.length)
  ), [matrix, keys])

  return (
    <div className="chord">
      {ready ? <MyChord matrix={matrix} keys={keys} /> : null}
    </div>
  )
}

export default ChordTest
